import { ISettings, SettingsApi } from '../interface';

export class SettingsMapper {
  public static toDomain(raw: SettingsApi): ISettings {
    return {
      countries: (raw.countries || []).map((country) => ({
        id: country.id,
        abbr: country.abbr,
        name: country.country_name,
        unit: country.unit,
      })),
      warehouse: raw.warehouse || [],
      workinghours: raw.workinghours || '',
    };
  }
}
